import { useState, useEffect } from "react";
import Select from 'react-select'
import { useLocation } from "react-router";
import { TooltipComponent, TooltipComponentMobile } from "../../Tooltip";

const MajorNameSearch = ({ setNameSelect, nameOptions, resetStateToggle, mobile = false }) => {

  const location = useLocation()
  const [selectedNames, setSelectedNames] = useState<any>([]);

  const handleNameSelectChange = (selectedNames) => {
    setSelectedNames(selectedNames);
    // let nameArr: any = []
    // selectedNames.map((name) =>
    //   nameArr.push(name.label)
    // )

    setNameSelect(selectedNames)
  };

  useEffect(() => {
    setSelectedNames([])
  }, [resetStateToggle])

  useEffect(() => {

    let params = new URLSearchParams(location.search);
    let namesParam = params.get('majorName');
    let res: any[] = []

    // if (namesParam) {
    //   const names = namesParam.split(',').map(name => ({ value: name, label: name }));
    //   handleNameSelectChange(names)
    // }

    if (namesParam && nameOptions) {
      const names = namesParam.split(',')
      names.map((val) => {
        if (nameOptions.find((obj => obj.value === parseInt(val)))) {
          res.push(nameOptions.find((obj => obj.value === parseInt(val))))
        }
      })
      handleNameSelectChange(res)
    }

    else {
      setSelectedNames([])
    }

  }, [location.search, nameOptions]);

  return (
    <div className='mt-4 d-flex flex-column'>
      <div className={`dca-aside-header ${mobile ? 'd-flex flex-row' : ''}`}>MAJOR NAME {mobile ? <span className="ms-2"><TooltipComponentMobile content={"Use this filter to find majors based on the exact major name as defined by the offering college(s)."} /></span> : <TooltipComponent content={"Use this filter to find majors based on the exact major name as defined by the offering college(s)."} />}</div>
      <Select
        options={nameOptions}
        styles={{
          control: (baseStyles, state) => ({
            ...baseStyles,
            border: 'transparent',
            backgroundColor: '#F9F9F9'
          }),
          menu: (baseStyles) => ({
            ...baseStyles,
            zIndex: 100
          })
        }}
        isMulti
        value={selectedNames}
        onChange={handleNameSelectChange}
      />
    </div>
  )
}

export { MajorNameSearch }
